// Navigation history manager for tracking page visits and restoring state
class NavigationHistoryManager {
  constructor() {
    this.history = [];
    this.currentIndex = -1;
  }

  // Add a new page to history with its scroll position and state
  addPage(path, scrollPosition = 0, pageState = {}) {
    // Remove any forward history if we're navigating back then forward
    if (this.currentIndex < this.history.length - 1) {
      this.history = this.history.slice(0, this.currentIndex + 1);
    }

    this.history.push({
      path,
      scrollPosition,
      pageState,
      timestamp: Date.now(),
    });

    this.currentIndex = this.history.length - 1;
  }

  // Get the previous page info
  getPreviousPage() {
    if (this.currentIndex > 0) {
      return this.history[this.currentIndex - 1];
    }
    return null;
  }

  // Go back in history
  goBack() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      return this.history[this.currentIndex];
    }
    return null;
  }

  // Go forward in history
  goForward() {
    if (this.currentIndex < this.history.length - 1) {
      this.currentIndex++;
      return this.history[this.currentIndex];
    }
    return null;
  }

  // Get current page
  getCurrentPage() {
    if (this.currentIndex >= 0 && this.currentIndex < this.history.length) {
      return this.history[this.currentIndex];
    }
    return null;
  }

  // Clear history
  clearHistory() {
    this.history = [];
    this.currentIndex = -1;
  }

  // Check if we can go back
  canGoBack() {
    return this.currentIndex > 0;
  }

  // Check if we can go forward
  canGoForward() {
    return this.currentIndex < this.history.length - 1;
  }

  // Get all history (for debugging)
  getFullHistory() {
    return this.history;
  }
}

export const navigationHistory = new NavigationHistoryManager();
